import ChangeCommentModal from '@/components/change-comment-modal';
import ClientActions from '@/components/client/client-actions';
import ClientAppsModal from '@/components/client/client-apps-modal';
import ClientDeviceMeta from '@/components/client/client-device-meta';
import ClientSimCards from '@/components/client/client-sim-cards';
import { Separator } from '@/components/ui/separator';
import type { IClient } from '@/entities/client.entity';
import { MessageCircleIcon } from 'lucide-react';
import { useMemo } from 'react';

interface ClientMetaProps {
	client: IClient;
	onCopy: (text: string) => void;
}

export default function ClientMeta({ client, onCopy }: ClientMetaProps) {
	const cards = useMemo(() => client.cards?.filter(c => c) ?? [], [client.cards]);

	return (
		<div className='px-2 py-2 bg-card border border-border rounded-md grid gap-2'>
			<div className='flex gap-1 items-center min-h-7'>
				<MessageCircleIcon size={14} className='opacity-40 shrink-0' />
				<span className='flex break-all items-center gap-0.5 min-w-0'>
					{client.comment ? (
						<button
							type='button'
							className='text-sm hover:bg-accent cursor-pointer select-none text-[#e89bff] text-left'
							onClick={() => onCopy(client.comment || '')}
						>
							{client.comment}
						</button>
					) : null}
					<ChangeCommentModal currentComment={client.comment} client={client} />
				</span>
			</div>

			<ClientSimCards
				client={client}
				phones={client.phones}
				cards={cards}
				cardFillJobs={client.cardFillJobs}
				onCopy={onCopy}
			/>
			<Separator />
			<ClientAppsModal client={client} onCopy={onCopy} />
			<Separator />
			<ClientActions client={client} />
			<Separator />
			<ClientDeviceMeta client={client} onCopy={onCopy} />
		</div>
	);
}
